import { render, staticRenderFns } from "./OrdersTabContent.vue?vue&type=template&id=0f61c4fe"
import script from "./OrdersTabContent.vue?vue&type=script&lang=js"
export * from "./OrdersTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports